import React from 'react'

export const UserRouteScreen = () => {
    return (
        <div>
            <h1>Soy el User Home</h1>
        </div>
    )
}
